/*=========================================================================================
  File Name: module-invoicefiles.js
  Description: InvoiceFiles Module
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import state from './module-invoicefiles-state';
import mutations from './module-invoicefiles-mutations';
import actions from './module-invoicefiles-actions';
import getters from './module-invoicefiles-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
